import { render, staticRenderFns } from "./ForgotPasswordForm.vue?vue&type=template&id=a7f9236e&scoped=true"
import script from "./ForgotPasswordForm.vue?vue&type=script&lang=js"
export * from "./ForgotPasswordForm.vue?vue&type=script&lang=js"
import style0 from "./ForgotPasswordForm.vue?vue&type=style&index=0&id=a7f9236e&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7f9236e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/tmp/build_997aa59e/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a7f9236e')) {
      api.createRecord('a7f9236e', component.options)
    } else {
      api.reload('a7f9236e', component.options)
    }
    module.hot.accept("./ForgotPasswordForm.vue?vue&type=template&id=a7f9236e&scoped=true", function () {
      api.rerender('a7f9236e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/auth/ForgotPasswordForm.vue"
export default component.exports